import { createStateContext } from '../../../factory'
import { SORT_ORDERS } from './const'

export const [ShopListContext, useShopListContext] = createStateContext({
  sortOrder: SORT_ORDERS[0]['value'],
})
